<div
  class="subsection-preview-component"
  [class.review-link-page]="!!subSectionState?.reviewLink"
  [class.has-pages]="activePages"
  [class.fullscreen]="isFullscreen">
  <div class="d-flex flex-column h-100">
    <div class="d-flex flex-column flex-xl-row preview-wrapper" [class.no-comment]="commentsCollapsed">
      <div
        class="media-player-container new-comment-ui"
        id="assetContainer"
        #assetContainer
        [class.comments-expanded]="!commentsCollapsed"
        [class.expanded]="commentsCollapsed">
        <ng-container *ngIf="!isSubsectionFile && !subSectionState?.activeFile?.isUploading">
          <ng-container *ngIf="subSectionState?.activeFile?.hasPage">
            <div
              class="d-flex has-pages-wrapper"
              *ngIf="activePages"
              [class.tree-expanded]="isCollapsed"
              [class.comment-collapsed]="commentsCollapsed">
              <ng-container *ngIf="!activePage">
                <div class="d-flex flex-column flex-fill">
                  <old-mtm-media-player
                    class="w-100"
                    #sliderMediaPlayerComponent
                    [instanceId]="instanceId"
                    [mode]="'view'"
                    [width]="'100%'"
                    [height]="'85%'"
                    [item]="subSectionState?.activeFile"
                    [projectId]="subSectionState?.section?.projectId"
                    [sectionId]="subSectionState?.section.id"
                    [subsectionId]="subSectionState?.subsection.id"
                    [projectParticipants]="projectParticipants"
                    [typeId]="subSectionState?.activeOption?.optionId"
                    [showDownloadButtonIfNotPreviewAble]="true"
                    *ngIf="subSectionState?.activeFile"
                    [respondToTaskQueue]="true"
                    [enableAnnotation]="true"
                    [(isAssetListVisible)]="isAssetListVisible"
                    [enableResponsive]="true"
                    [commentOnly]="true"></old-mtm-media-player>
                  <subsection-page-list
                    [filePages]="activePages"
                    [subsectionState]="subSectionState"
                    [isReviewLinkPage]="!!subSectionState?.reviewLink"
                    [isWidgetMode]="isWidgetMode"
                    class=""
                    (pageClick)="onPageClick($event)"></subsection-page-list>
                </div>
              </ng-container>
              <ng-container *ngIf="activePage">
                <mtm-pdf-slider-component
                  [filePages]="activePages"
                  [activePage]="activePage"
                  [collapsed]="pdfSliderCollapsed"
                  (collapsedChange)="topMediaInfoService.updatePdfSliderCollapsed($event)"
                  (pageClick)="onPageClick($event)"></mtm-pdf-slider-component>
                <old-mtm-media-player
                  class="w-100"
                  #sliderMediaPlayerComponent
                  [instanceId]="instanceId"
                  [mode]="'view'"
                  [width]="'100%'"
                  [height]="'85%'"
                  [item]="subSectionState?.activeFile"
                  [projectId]="subSectionState?.section.projectId"
                  [sectionId]="subSectionState?.section.id"
                  [subsectionId]="subSectionState?.subsection.id"
                  [projectParticipants]="projectParticipants"
                  [typeId]="subSectionState?.activeOption?.optionId"
                  [showDownloadButtonIfNotPreviewAble]="true"
                  *ngIf="subSectionState?.activeFile"
                  [enableAnnotation]="true"
                  [(isAssetListVisible)]="isAssetListVisible"
                  [enableResponsive]="true"
                  [filePages]="subSectionState?.activeFilePages"
                  [activePage]="subSectionState?.activePage"
                  [enablePage]="true"></old-mtm-media-player>
              </ng-container>
            </div>
            <div
              class="d-flex w-100 h-100 position-absolute align-items-center justify-content-center processing-preview"
              role="status"
              *ngIf="!activePages">
              <span class="d-inline-block mb-2">
                <mtm-loading-spinner [size]="24"></mtm-loading-spinner>
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="!subSectionState?.activeFile?.hasPage">
            <old-mtm-media-player
              class="w-100"
              #sliderMediaPlayerComponent
              [instanceId]="instanceId"
              [mode]="'view'"
              [width]="'100%'"
              [height]="'85%'"
              [item]="subSectionState?.activeFile"
              [projectId]="subSectionState?.section.projectId"
              [sectionId]="subSectionState?.section.id"
              [subsectionId]="subSectionState?.subsection.id"
              [projectParticipants]="projectParticipants"
              [typeId]="subSectionState?.activeOption?.optionId"
              [showDownloadButtonIfNotPreviewAble]="true"
              *ngIf="subSectionState?.activeFile"
              [enableAnnotation]="true"
              [(isAssetListVisible)]="isAssetListVisible"
              [enableResponsive]="true"
              [filePages]="subSectionState?.activeFilePages"
              [activePage]="subSectionState?.activePage"
              [enablePage]="true"></old-mtm-media-player>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="isSubsectionFile && !subSectionState?.activeFile?.isUploading">
          <old-mtm-media-player
            class="w-100"
            #sliderMediaPlayerComponent
            [instanceId]="instanceId"
            [mode]="'view'"
            [width]="'100%'"
            [height]="'85%'"
            [item]="subSectionState?.activeFile"
            [projectId]="subSectionState?.section.projectId"
            [sectionId]="subSectionState?.section.id"
            [subsectionId]="subSectionState?.subsection.id"
            [projectParticipants]="projectParticipants"
            [typeId]="subSectionState?.versionData?.optionId"
            [showDownloadButtonIfNotPreviewAble]="true"
            *ngIf="subSectionState?.activeFile"
            [enableAnnotation]="true"
            [isAssetListVisible]="false"
            [enableResponsive]="true"></old-mtm-media-player>
        </ng-container>
        <ng-container *ngIf="subSectionState?.activeFile?.isUploading">
          <div
            class="d-flex w-100 position-absolute align-items-center justify-content-center uploading-preview"
            role="status">
            <mtm-radial-transfer-bar
              [bgColor]="'#FFF'"
              [radius]="70"
              [strokeWidth]="10"
              *ngIf="uploadRecord[subSectionState?.activeFile.id]"
              [percentage]="uploadRecord[subSectionState?.activeFile?.id].progress">
            </mtm-radial-transfer-bar>
            <div class="uploading-text">{{ 'uploading' | translate }}</div>
          </div>
        </ng-container>
      </div>
      <ng-template #mediaPreviewCommentsChat>
        <ng-template
          #profilePictureTemplate
          let-username="username"
          let-width="width"
          let-height="height"
          let-fontSize="fontSize">
          <mtm-user-profile-picture
            [style.min-width]="'21px'"
            [width]="width"
            [height]="height"
            [username]="username"
            [fontSize]="fontSize" />
        </ng-template>
        <div
          class="d-flex flex-column comments-container w-100"
          [class.fullscreen]="isFullscreen"
          [conversationThreadHighlight]="highlightedAnnotationId">
          <conversation-interface
            class="d-flex flex-fill"
            [ngClass]="{ 'mt-2 mt-md-0 mb-2 mb-md-0': !commentsCollapsed }"
            [annotationPlugin]="annotationPlugin"
            [profilePictureTemplate]="profilePictureTemplate"
            [entityName]="subSectionState?.activePage?.name || subSectionState?.activeFile?.displayName"
            [instanceId]="instanceId"
            [isFullscreen]="isFullscreen"
            [readOnly]="isCurrentVersionLocked"
            [currentUser]="currentUsername"
            [mediaType]="activeFileMediaType"
            [drawingTools]="drawingTools"
            [startTime]="startTime"
            [endTime]="endTime"
            [duration]="duration"
            [viewMode]="isCommentPanelFullSize ? 'split' : 'toggle'"
            [navigationRequest]="navigationRequest"
            (onSelectThread)="onSelectThread($event)"
            (onEditMessage)="onEditMessage($event)"
            (onShowChannelManager)="onShowChannelManager($event)"
            (onCloseChannelManager)="onCloseChannelManager()"
            (onStartTimeChange)="onStartTimeRangeChange($event)"
            (onEndTimeChange)="onEndTimeRangeChange($event)"
            (onUpdateEditMessage)="handleUpdateEditMessage($event)"
            (onSendVideoMessage)="handleSendVideoMessage($event)"
            (onSendImageMessage)="handleSendImageMessage($event)"
            (onSendAudioMessage)="handleSendAudioMessage($event)"
            (onSendOtherTypesMessage)="handleSendOtherTypesMessage($event)"
            (onToolSelect)="handleToolSelect($event)"
            (onColorSelect)="handleColorSelect($event)"></conversation-interface>
        </div>
      </ng-template>
    </div>
  </div>
</div>
